import { PaginationType } from "@/models/common";
import {
  DriverWorkCycleOrder,
  DriverWorkCycleSortKey,
  OfficeRelatedShiftAndCycle,
} from "@/models/driverWorkShiftsAndCycle";
import {
  DriverWorkCyclesConstants,
  PAGE_SIZE,
} from "@/pages/DriverWorkCycles/DriverWorkCyclesConstants";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { CommonButton } from "../common/buttons/CommonButton";
import { Pagination } from "../molecules/Pagination";

export type DriverWorkCycleListProps = {
  driverWorkCycles: OfficeRelatedShiftAndCycle[];
  pagingData: PaginationType;
  orderTypes: DriverWorkCycleOrder;
  onChangePage: (page: number) => void;
  onChangeSort: (key: DriverWorkCycleSortKey) => void;
  onClickEdit: (id: number) => void;
};

export const DriverWorkCycleList = ({
  driverWorkCycles,
  pagingData,
  orderTypes,
  onChangePage,
  onChangeSort,
  onClickEdit,
}: DriverWorkCycleListProps) => (
  <>
    <TableContainer className="table-container-width">
      <Table size="small">
        <TableHead className="list-head">
          <TableRow>
            <TableCell className="table-cell-width-custom">
              {DriverWorkCyclesConstants.OfficeName}
              <TableSortLabel
                active={
                  driverWorkCycles.length > 0 &&
                  !!orderTypes["offices.displayName"]
                }
                direction={
                  orderTypes["offices.displayName"] === "desc" ? "desc" : "asc"
                }
                sx={{ ":hover": { color: "red" } }}
                onClick={() => onChangeSort("offices.displayName")}
              />
            </TableCell>
            <TableCell>
              {DriverWorkCyclesConstants.DriverWorkShiftName}
            </TableCell>
            <TableCell>
              {DriverWorkCyclesConstants.DriverWorkCycleName}
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{ wordBreak: "break-all" }}>
          {driverWorkCycles.map((row) => (
            <TableRow key={row.officeId} hover>
              <TableCell>{row.offices?.displayName ?? ""}</TableCell>
              <TableCell>
                {row.driverWorkShifts
                  ?.map(({ shortName }) => shortName)
                  .join(",")}
              </TableCell>
              <TableCell>
                {row.driverWorkCycles
                  ?.map(({ shortName }) => shortName)
                  .join(",")}
              </TableCell>
              <TableCell sx={{ textAlign: "right", pr: 0 }}>
                <CommonButton
                  btnType="Detail"
                  onClickBtn={() => onClickEdit(row.officeId ?? 0)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <Pagination
      total={pagingData.total}
      page={pagingData.page}
      size={pagingData.size ?? PAGE_SIZE}
      setPage={onChangePage}
    />
  </>
);
